import {
  RadioGroup,
  Box,
  FormControlLabel,
  Radio,
  Typography,
  IconButton,
} from "@mui/material";
import TextInput from "../../../../../../components/textinput/textinput";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

type Props = {
  formik: any;
  certificationMethods: any;
  uploadedCertificate: any;
  handleCertificateFileChange: any;
  handleCertificateFileDelete: any;
  setUploadedCertificate: any;
  setDeleteCertificate: any;
  selectedCertificateFile: any;
  onCertificationMethodChange?: (method: string) => void;
  data: any;
};

const FannieMae = (props: Props) => {
  const {
    formik,
    certificationMethods,
    uploadedCertificate,
    handleCertificateFileChange,
    handleCertificateFileDelete,
    setUploadedCertificate,
    setDeleteCertificate,
    selectedCertificateFile,
    onCertificationMethodChange,
    data,
  } = props;
  return (
    <RadioGroup
      value={formik.values.certificationMethod}
      onChange={(event) => {
        if (onCertificationMethodChange) {
          onCertificationMethodChange(event.target.value);
        } else {
          formik.setFieldValue("certificationMethod", event.target.value);
        }
      }}
      onBlur={() => formik.setFieldTouched("certificationMethod", true)}
    >
      <Box sx={{ pl: "36px", mt: "10px" }}>
        {certificationMethods
          .filter((type: any) => type.certificationType === "FannieMae")
          .map((type: any, index: number) => (
            <Box
              key={type.certificationMethod}
              sx={{
                border:
                  formik.values.certificationMethod === type.certificationMethod
                    ? "1px solid"
                    : "1px solid transparent",
                borderColor:
                  formik.values.certificationMethod === type.certificationMethod
                    ? "primary.main"
                    : "transparent",
                borderRadius: "8px",
                p:
                  formik.values.certificationMethod === type.certificationMethod
                    ? 1
                    : "2px 4px",
                mb: 0.25,
                backgroundColor:
                  formik.values.certificationMethod === type.certificationMethod
                    ? "#E35F000A"
                    : "transparent",
                width: "742px",
                minHeight:
                  formik.values.certificationMethod === type.certificationMethod
                    ? "auto"
                    : "28px",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <FormControlLabel
                value={type.certificationMethod}
                control={<Radio size="small" />}
                sx={{
                  alignItems: "flex-start",
                  margin: 0,
                  width: "100%",
                  "& .MuiFormControlLabel-label": {
                    marginTop: 0,
                    marginLeft: 0,
                    width: "100%",
                  },
                  "& .MuiRadio-root": {
                    padding: 0,
                    marginRight: 1,
                  },
                }}
                label={
                  <Box sx={{ mt: 0 }}>
                    <Typography sx={{ fontSize: "0.875rem" }}>
                      {type.displayName}
                    </Typography>
                    {formik.values.certificationMethod ===
                      type.certificationMethod && (
                      <Box sx={{ pt: 2, pb: 1 }}>
                        {type.certificationMethod === "HUDREAC" ? (
                          <TextInput
                            name="certificateNumber"
                            value={formik.values.certificateNumber}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Enter certificate number"
                            label="M Number"
                            fullWidth
                            error={
                              formik.touched.certificateNumber &&
                              Boolean(formik.errors.certificateNumber)
                            }
                            helperText={
                              formik.touched.certificateNumber &&
                              formik.errors.certificateNumber
                                ? (formik.errors.certificateNumber as string)
                                : ""
                            }
                            sx={{
                              width: "100%",
                              minWidth: "700px",
                              "& .MuiInputLabel-root": {
                                color: "grey",
                                "&.Mui-focused": {
                                  color: "grey",
                                },
                              },
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "white",
                                "& fieldset": {
                                  border: "1px solid",
                                  borderColor: "gray",
                                },
                                "&:hover fieldset": {
                                  border: "1px solid",
                                  borderColor: "gray",
                                },
                                "&.Mui-focused fieldset": {
                                  border: "1px solid",
                                  borderColor: "gray",
                                },
                              },
                              "& .MuiFormHelperText-root": {
                                backgroundColor: "transparent",
                                margin: 0,
                                marginTop: 0.5,
                              },
                            }}
                            size="small"
                          />
                        ) : (
                          <Box>
                            {!uploadedCertificate &&
                              !formik.values.certificate &&
                              !selectedCertificateFile && (
                                <Box
                                  sx={{
                                    height: 80,
                                    width: "700px",
                                    border: formik.errors.certificate
                                      ? "1px solid red"
                                      : "1px dashed rgba(0, 0, 0, 0.12)",
                                    position: "relative",
                                    backgroundColor: "white",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <UploadFileIcon
                                    sx={{ ml: 5 }}
                                    color="primary"
                                  />
                                  <Box ml={2}>
                                    <Box sx={{ display: "flex" }}>
                                      <Typography
                                        color="primary"
                                        sx={{
                                          textDecoration: "underline",
                                        }}
                                      >
                                        Click to upload
                                      </Typography>
                                      <Typography sx={{ ml: 1 }}>
                                        or drag and drop
                                      </Typography>
                                    </Box>
                                    <Typography
                                      sx={{
                                        color: "rgba(0, 0, 0, 0.6)",
                                      }}
                                    >
                                      PDF, JPG or PNG (max. 10MB)
                                    </Typography>
                                  </Box>
                                  <input
                                    style={{
                                      display: "block",
                                      height: 80,
                                      width: "100%",
                                      position: "absolute",
                                      top: 0,
                                      right: 0,
                                      bottom: 0,
                                      left: 0,
                                      opacity: 0,
                                      cursor: "pointer",
                                    }}
                                    type="file"
                                    accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/jpg,image/png"
                                    onChange={(event) =>
                                      handleCertificateFileChange(event)
                                    }
                                    name="certificate"
                                    onClick={(event) => {
                                      (event.target as HTMLInputElement).value =
                                        "";
                                    }}
                                  />
                                </Box>
                              )}
                            {(selectedCertificateFile ||
                              (formik.values.certificate &&
                                formik.values.certificate !==
                                  data?.certificateFileName)) && (
                              <Box
                                sx={{
                                  mt: 2,
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  border: formik.errors.certificate
                                    ? "1.5px solid red"
                                    : "1.5px solid green",
                                  p: 0.8,
                                  borderRadius: 1,
                                  backgroundColor: formik.errors.certificate
                                    ? "#FFF5F5"
                                    : "#F7FAF7",
                                }}
                              >
                                <Box display={"flex"} alignItems={"center"}>
                                  <AttachFileOutlinedIcon color="primary" />
                                  <Box sx={{ ml: 1.5 }}>
                                    <Typography>
                                      {selectedCertificateFile?.name ||
                                        (formik.values.certificate instanceof
                                        File
                                          ? formik.values.certificate.name
                                          : formik.values.certificate) ||
                                        "No file selected"}
                                    </Typography>
                                    <Typography>
                                      {" "}
                                      {selectedCertificateFile
                                        ? `${(
                                            selectedCertificateFile.size / 1024
                                          ).toFixed(2)} kb`
                                        : formik.values.certificate instanceof
                                          File
                                        ? `${(
                                            formik.values.certificate.size /
                                            1024
                                          ).toFixed(2)} kb`
                                        : ""}
                                    </Typography>
                                  </Box>
                                </Box>
                                <Box>
                                  <IconButton
                                    aria-label="delete"
                                    onClick={handleCertificateFileDelete}
                                  >
                                    <RemoveCircleOutlineIcon color="error" />
                                  </IconButton>
                                </Box>
                              </Box>
                            )}
                            {uploadedCertificate &&
                              !selectedCertificateFile &&
                              formik.values.certificate ===
                                data?.certificateFileName && (
                                <Box
                                  sx={{
                                    mt: 2,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "1.5px solid green",
                                    p: 0.8,
                                    borderRadius: 1,
                                    backgroundColor: "#F7FAF7",
                                  }}
                                >
                                  <Box display={"flex"} alignItems={"center"}>
                                    <AttachFileOutlinedIcon color="primary" />
                                    <Box sx={{ ml: 1.5 }}>
                                      <Typography>
                                        {uploadedCertificate}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          color: "rgba(0, 0, 0, 0.6)",
                                        }}
                                      >
                                        Complete
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <CheckCircleOutlineIcon
                                      color="success"
                                      sx={{ mr: 2 }}
                                    />
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() => {
                                        setUploadedCertificate("");
                                        formik.setFieldValue("certificate", "");
                                        if (data?.certificateFileName) {
                                          setDeleteCertificate(true);
                                        }
                                      }}
                                    >
                                      <DeleteOutlinedIcon color="error" />
                                    </IconButton>
                                  </Box>
                                </Box>
                              )}
                            {formik.errors.certificate && (
                              <Typography
                                sx={{ fontSize: 12, mt: 0.5 }}
                                color="error"
                              >
                                {formik.errors.certificate as string}
                              </Typography>
                            )}
                          </Box>
                        )}
                      </Box>
                    )}
                  </Box>
                }
              />
            </Box>
          ))}
      </Box>
    </RadioGroup>
  );
};

export default FannieMae;
